/**
 * Collapsible order section mimicking EHR order set styling.
 */
import { FC, useState } from 'react'
import { InlineMd } from './InlineMd'

export const CollapsibleOrderSection: FC<{
  title: string
  items: string[]
  defaultOpen?: boolean
}> = ({ title, items, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen)
  const hasContent = items && items.length > 0

  return (
    <div className="border border-border rounded-lg overflow-hidden mb-1.5">
      <button
        onClick={() => setOpen(v => !v)}
        className={`w-full flex items-center justify-between px-3 py-2 text-left text-xs font-semibold transition-colors ${
          hasContent
            ? 'bg-blue-500/10 text-primary hover:bg-blue-500/15'
            : 'bg-muted text-muted-foreground hover:bg-muted/80'
        }`}
      >
        <span>{title}</span>
        <span className="text-[10px] text-muted-foreground">{open ? '\u25BC' : '\u25B6'}</span>
      </button>
      {open && hasContent && (
        <div className="px-3 py-2 space-y-0.5 bg-card">
          {items.map((item, i) => (
            <div key={i} className="text-xs text-muted-foreground leading-relaxed flex items-start gap-1.5">
              <span className="text-muted-foreground/60 mt-0.5 flex-shrink-0">&bull;</span>
              <span><InlineMd>{item}</InlineMd></span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
